// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] || chunkId) + "." + {"38":"eb66f35df9614032","440":"db706bdc13096ef4","581":"f5ee58b61882be6f"}[chunkId] + ".js";
};